export default () => (scope, element, attrs) => element.bind("keydown keypress", function (event) {
    if (event.which === 13) {
        console.log('ngEnter.$apply', attrs);
        setTimeout(function () {
            scope.$apply(function () {
                console.warn(attrs.ngEnterDelay, { 'event': event, '$value': element.val() });
                scope.$eval(attrs.ngEnterDelay, { 'event': event, '$value': element.val() });
            });
        }, 500);

        event.preventDefault();
    }
});